import type { GetInventoryLocationsInput, InventoryLocationCreateDto, InventoryLocationDto, InventoryLocationUpdateDto, InventoryLocationWithNavigationPropertiesDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class InventoryLocationService {
  apiName = 'Inventory';

  create = (input: InventoryLocationCreateDto) =>
    this.restService.request<any, InventoryLocationDto>({
      method: 'POST',
      url: '/api/inventory/inventory-locations',
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/inventory/inventory-locations/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, InventoryLocationDto>({
      method: 'GET',
      url: `/api/inventory/inventory-locations/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetInventoryLocationsInput) =>
    this.restService.request<any, PagedResultDto<InventoryLocationWithNavigationPropertiesDto>>({
      method: 'GET',
      url: '/api/inventory/inventory-locations',
      params: { filterText: input.filterText, name: input.name, description: input.description, code: input.code, inventoryLocationId: input.inventoryLocationId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, InventoryLocationWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/inventory/inventory-locations/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: InventoryLocationUpdateDto) =>
    this.restService.request<any, InventoryLocationDto>({
      method: 'PUT',
      url: `/api/inventory/inventory-locations/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  getInventoryLocationLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: '/api/inventory/inventory-locations/location-lookup',
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
